import {
  GENERATE_GLOBAL_NORMS,
  GLOBAL_NORMS_LIST,
  GROUP_NORMS_LIST,
  GROUP_NORMS_DETAILS_LIST,

  NORMS_SUCCESS,
  NORMS_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
}

const EmailBatch = (state = initialState, action) => {
  switch (action.type) {

    // Generate Global Norms
    case GENERATE_GLOBAL_NORMS:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // global norms list
    case GLOBAL_NORMS_LIST:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    case GROUP_NORMS_LIST:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    case GROUP_NORMS_DETAILS_LIST:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    case NORMS_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
      }
      break

    case NORMS_ERROR:
      state = { ...state, error: action.payload, loading: false, }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default EmailBatch
